import { TYPES } from "./types";
import { eitShopSoldService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getEITShopSoldStat = (query) => async (dispatch) => {

  try {
    const result = await eitShopSoldService.getEITShopSoldStat(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_STAT_SUCCESS,
        payload: {data, shopName: query.shopName }
      });

      // dispatch(setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, true))
    } else {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_STAT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getEITShopSoldStatGroup = (query) => async (dispatch) => {

  try {
    const result = await eitShopSoldService.getEITShopSoldStatGroup(query);
    const data = result.data.data.result;
    
    if (data) {
      // fix duplicate

      var fixedData = [];


      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_SUCCESS,
        payload: { data, type: query.type }
      });

      // dispatch(setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, true))
    } else {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_STAT_GROUP_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getEITShopSold = (query) => async (dispatch) => {
  try {
    const result = await eitShopSoldService.getEITShopSold(query);
    const data = result.data.data;

    console.log("query", query, data);
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_SUCCESS,
        payload: {data, shopName: query.shopName}
      });

      // dispatch(setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, true))
    } else {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOP_SOLD_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getLatestShopSold = (shopName) => async (dispatch) => {

  try {
    const result = await eitShopSoldService.getEITShopSold({shopName, limit: 1, sortBy: "-timestamp"});
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_LATEST_SHOP_SOLD_SUCCESS,
        payload: {data, shopName}
      });

      // dispatch(setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, true))
    } else {
      dispatch({
        type: TYPES.ACTION_GET_LATEST_SHOP_SOLD_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const eitShopSoldAction = {
  getEITShopSoldStat,
  getEITShopSoldStatGroup,
  getEITShopSold,
  getLatestShopSold
};
